import { useQuery } from '@tanstack/react-query';
import { USD_DECIMALS } from '@ui/constants/numbersDecimals';
import { getPoolTokenByAddress } from '@ui/constants/tokens';
import { useDataChainId } from '@ui/hooks/datachain';
import { toReadableValue } from '@ui/lib/bignumber';
import { objectFromEntries } from '@ui/utils/objectFromEntries';
import BigNumber from 'bignumber.js';
import { usePublicClient } from 'wagmi';

import { getTradingCoreFacet } from '../../contract-instances/getTradingCoreFacet';

export type LpUnrealizedPnl = {
  /**
   * unrealizedPnL in doc
   */
  totalUnrealizedPnlUsd: BigNumber;
  /**
   * unrealizedPnL * tokenRatio in doc
   */
  unrealizedPnlMap: {
    [x: string]: BigNumber;
  };
};

export const useLpUnrealizedPnlUsd = () => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });

  return useQuery({
    enabled: !!client?.uid,
    // assuming once fetched, the data will changed afterwards
    staleTime: 0,
    gcTime: 0,
    queryKey: ['TradingCoreFacet.lpUnrealizedPnlUsd', client?.uid, chainId],
    queryFn: async (): Promise<LpUnrealizedPnl | undefined> => {
      if (!client) throw new Error('client missing');
      const contract = getTradingCoreFacet({
        chainId,
        publicClient: client,
      });
      const result = await contract.read.lpUnrealizedPnlUsd();

      const [totalUsd, tokensData] = result;
      const entries = tokensData.map((data): [string, BigNumber] => {
        const feConfig = getPoolTokenByAddress(data.token, chainId);
        if (!feConfig) {
          console.error(`token: ${data.token} not found in FE config`);
        }

        return [
          data.token.toLowerCase(),

          toReadableValue(data.unPnlUsd, USD_DECIMALS),
        ];
      });
      const unrealizedPnlMap = objectFromEntries(entries);

      return {
        totalUnrealizedPnlUsd: toReadableValue(totalUsd, USD_DECIMALS),
        unrealizedPnlMap,
      };
    },
  });
};
